import { blackColors, grayColor } from 'assets/jss/material-dashboard-pro-react';

const summaryStyle = () => ({
	userNameLabel: {
		background: grayColor[24],
		display: 'flex',
		alignItems: 'end',
		borderRadius: '0px',
		borderBottom: '1px solid #efeeee',
		marginBottom: '10px',
		marginTop: '20px',
		padding: '15px',
		minWidth: '200px',
	},
	userNameWrapper: {
		display: 'flex',
		alignItems: 'baseline'
	},
	planSummaryContainer: {
		marginTop: 16,
		marginBottom: 26,
	},
	summaryContainer: {
		marginTop:'10px'
	},
	summary: {
		paddingTop: 10,
		display: 'flex',
		borderTop: `1px solid ${blackColors[5]}`,
		padding: '3%',
		borderRadius: '15px',
		backgroundColor: grayColor[16]
	},
	flex1: {
		flex: 1,
		display: 'flex',
	},
	alignRight: {
		textAlign: 'right',
		flexDirection: 'column',
		display: 'flex',
	},
	alignCenter: {
		alignItems: 'center',
	},
	vat: {
		paddingLeft: '3%',
	},
	tc: {
		paddingLeft: '3%',
		display: 'inline-block',
		width: 'auto'
	},
});

export default summaryStyle;
